/* Curvana global UI behaviors: native <dialog> open/close via data attributes.
   [data-cv-open="dialog-id"] opens; [data-cv-close] closes nearest dialog;
   clicking the dialog backdrop area closes it.

   When a modal dialog opens we lock the page scroll using the position:fixed
   body technique and restore the exact scroll position on close. This prevents
   the mobile bug where, after closing the size-quiz popup, the background page
   shifts to the left and the header / announcement bar get cut off on the right
   (iOS Safari scrolls the background behind a modal and never restores it). */
(function () {
  var scrollLockY = 0;
  var lockCount = 0;

  function lockScroll() {
    if (lockCount === 0) {
      scrollLockY = window.scrollY || window.pageYOffset || 0;
      var body = document.body;
      body.style.position = 'fixed';
      body.style.top = -scrollLockY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
    }
    lockCount++;
  }

  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      var body = document.body;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      body.style.overflow = '';
      window.scrollTo(0, scrollLockY);
    }
  }

  function openDialog(dlg) {
    if (!dlg || typeof dlg.showModal !== 'function') { return; }
    lockScroll();
    // Unlock on ANY close path (button, backdrop, Escape) via the native event.
    dlg.addEventListener('close', function onClose() {
      dlg.removeEventListener('close', onClose);
      unlockScroll();
    });
    dlg.showModal();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cv-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-cv-open'));
      if (dlg && typeof dlg.showModal === 'function') {
        e.preventDefault();
        openDialog(dlg);
      }
      return;
    }
    // Offer-seeking CTAs (final CTA) behave like the sticky ATC when an offer
    // selector is on the page: reveal its pickers instead of navigating away.
    var seeker = e.target.closest('[data-cv-offer-cta]');
    if (seeker && document.querySelector('cv-offer')) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('curvana:focus-options', { bubbles: true }));
      return;
    }

    // Carousel thumbnails scroll the swipeable stage to the chosen slide.
    var thumb = e.target.closest('.cv-carousel__thumb');
    if (thumb) {
      var carousel = thumb.closest('.cv-carousel');
      if (carousel) {
        var idx = parseInt(thumb.getAttribute('data-thumb'), 10) || 0;
        var stage = carousel.querySelector('.cv-carousel__stage');
        if (stage) {
          stage.scrollTo({ left: stage.clientWidth * idx, behavior: 'smooth' });
        }
        setActiveSlide(carousel, idx);
      }
      return;
    }
    var closer = e.target.closest('[data-cv-close]');
    if (closer) {
      var d = closer.closest('dialog');
      if (d) {
        e.preventDefault();
        d.close();
      }
      return;
    }
    // Click on the dialog element itself (outside the panel) closes it.
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('cv-modal')) {
      e.target.close();
    }
  });

  // ---- Carousel: keep the active thumb in sync with the scroll position ----
  function setActiveSlide(carousel, idx) {
    carousel.querySelectorAll('.cv-carousel__thumb').forEach(function (t) {
      t.classList.toggle('is-active', (parseInt(t.getAttribute('data-thumb'), 10) || 0) === idx);
    });
    carousel.querySelectorAll('.cv-carousel__slide').forEach(function (s) {
      s.classList.toggle('is-active', (parseInt(s.getAttribute('data-slide'), 10) || 0) === idx);
    });
  }

  function initCarousel(carousel) {
    var stage = carousel.querySelector('.cv-carousel__stage');
    if (!stage || stage.dataset.cvInit) { return; }
    stage.dataset.cvInit = '1';
    var ticking = false;
    stage.addEventListener('scroll', function () {
      if (ticking) { return; }
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (!stage.clientWidth) { return; }
        setActiveSlide(carousel, Math.round(stage.scrollLeft / stage.clientWidth) || 0);
      });
    }, { passive: true });
  }

  function initCarousels(root) {
    (root || document).querySelectorAll('.cv-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  } else {
    initCarousels();
  }
  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
})();
